import SideBar from './SideBar';
import reducer from './reducer';

export { reducer };
export default SideBar;
